"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const CircularProgress_1 = tslib_1.__importDefault(require("@mui/material/CircularProgress"));
const Fade_1 = tslib_1.__importDefault(require("@mui/material/Fade"));
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
const CloudDownload_1 = tslib_1.__importDefault(require("@mui/icons-material/CloudDownload"));
const ButtonExport = ({ loading, ...rest }) => (react_1.default.createElement(IconButton_1.default, { ...rest, size: "large" }, loading ? (react_1.default.createElement(Fade_1.default, { in: true },
    react_1.default.createElement(CircularProgress_1.default, { color: "secondary", size: 24 }))) : (react_1.default.createElement(CloudDownload_1.default, null))));
exports.default = ButtonExport;
